import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import { ButtonAlert, ButtonModalSecondary, ButtonPrimary } from 'components/buttons';
import { Close } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import './styles.scss';

/**
 * General component description.
 */
class DialogModal extends PureComponent {
    constructor(props) {
        super(props);

        this.rootSelector = document.getElementById('modal-root');
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.rootSelector.appendChild(this.el);
    }

    componentWillUnmount() {
        this.rootSelector.removeChild(this.el);
    }

    renderBody() {
        const { children, text = '' } = this.props;
        if (children !== null) {
            return children;
        }
        return <Literal literal={text} />;
    }

    renderChildren() {
        const {
            isOpen,
            isAlert,
            title,
            cancelText = 'cfm_action_cancel',
            successText = 'cfm_action_accept',
            closeModal = () => null,
            onSuccess = () => null,
        } = this.props;
        const className = `dialog-modal ${isOpen ? 'show' : ''}`;

        if (isOpen === false) {
            return null;
        }

        return (
            <Fragment>
                <div className="modal-overlay" />
                <div className={className}>
                    <div className="dialog-header">
                        <span className="dialog-header__text">
                            <Literal literal={title} />
                        </span>
                        <div
                            role="button"
                            tabIndex="-1"
                            className="dialog-header__close-btn"
                            onClick={closeModal}
                        >
                            <Close color={CFM_STONE} />
                        </div>
                    </div>
                    <div className="dialog-content">
                        <div className="dialog-text">{this.renderBody()}</div>
                    </div>
                    <div className="dialog-footer">
                        <ButtonModalSecondary
                            dataTest="close"
                            onClick={closeModal}
                            classNames={['dialog-footer-btn']}
                        >
                            <Literal literal={cancelText} />
                        </ButtonModalSecondary>
                        {isAlert ? (
                            <ButtonAlert
                                dataTest="confirm"
                                onClick={onSuccess}
                                classNames={['dialog-footer-btn']}
                            >
                                <Literal literal={successText} />
                            </ButtonAlert>
                        ) : (
                            <ButtonPrimary
                                dataTest="confirm"
                                onClick={onSuccess}
                                classNames={['dialog-footer-btn']}
                            >
                                <Literal literal={successText} />
                            </ButtonPrimary>
                        )}
                    </div>
                </div>
            </Fragment>
        );
    }

    render() {
        return ReactDOM.createPortal(this.renderChildren(), this.el);
    }
}

DialogModal.propTypes = {
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Literal key for title */
    title: PropTypes.string,
    /** Literal key for Description */
    text: PropTypes.string,
    /** Literal key for cancel button */
    cancelText: PropTypes.string,
    /** children if you want to add a component in the body instead of the text  */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    /** Function to call when close modal */
    closeModal: PropTypes.func,
    /** if is alert -> Done button in red color */
    isAlert: PropTypes.bool,
    /** Success action */
    onSuccess: PropTypes.func,
    /** Literal key for success button */
    successText: PropTypes.string,
};

export default DialogModal;
